module.exports = __webpack_public_path__ + "static/precision-ute-70184229a9cbf82a8c9a0a8fc3204e09.jpg";